import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Import components
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import EmailTemplates from './components/EmailTemplates';
import EmailLogs from './components/EmailLogs';
import Recipients from './components/Recipients';
import Domains from './components/Domains';
import Testing from './components/Testing';
import Settings from './components/Settings';
import AgentSystem from './components/AgentSystem';
import EmailTracking from './components/EmailTracking';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Navbar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        
        <div className="flex">
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
          
          {/* Mobile sidebar overlay */}
          {sidebarOpen && (
            <div 
              className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
              onClick={() => setSidebarOpen(false)}
            />
          )}
          
          <main className="flex-1 lg:ml-64 transition-all duration-200 ease-in-out">
            <div className="p-4 sm:p-6">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/templates" element={<EmailTemplates />} />
                <Route path="/logs" element={<EmailLogs />} />
                <Route path="/recipients" element={<Recipients />} />
                <Route path="/domains" element={<Domains />} />
                <Route path="/testing" element={<Testing />} />
                <Route path="/agents" element={<AgentSystem />} />
                <Route path="/email-tracking" element={<EmailTracking />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </div>
          </main>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          className="mt-16 sm:mt-0"
        />
      </div>
    </Router>
  );
}

export default App;
